import React, { useState, useEffect } from 'react';
import { RefreshCw, X } from 'lucide-react';

/**
 * Non-blocking notification for Service Worker updates.
 * Instead of using blocking confirm(), this shows a beautiful toast
 * with "Muat Ulang" button to activate the new version.
 */
const UpdateNotification = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = () => setShow(true);
    window.addEventListener('sw:update-available', handler);
    return () => window.removeEventListener('sw:update-available', handler);
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  const handleDismiss = () => {
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-20 right-4 z-50 animate-slide-up">
      <div className="bg-white border border-blue-200 rounded-xl shadow-2xl p-4 max-w-sm backdrop-blur-sm">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0 p-2 bg-blue-100 rounded-lg">
            <RefreshCw className="w-5 h-5 text-blue-600" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-gray-900">
              Update Tersedia
            </p>
            <p className="mt-1 text-xs text-gray-500">
              Versi baru aplikasi siap. Muat ulang untuk mengaktifkan.
            </p>
            <div className="mt-3 flex items-center space-x-2">
              <button
                onClick={handleReload}
                className="inline-flex items-center px-3 py-1.5 bg-blue-600 text-white text-xs font-semibold rounded-lg hover:bg-blue-700 transition-colors shadow-sm"
              >
                <RefreshCw className="w-3.5 h-3.5 mr-1.5" />
                Muat Ulang
              </button>
              <button
                onClick={handleDismiss}
                className="inline-flex items-center px-3 py-1.5 bg-gray-100 text-gray-600 text-xs font-semibold rounded-lg hover:bg-gray-200 transition-colors"
              >
                Nanti
              </button>
            </div>
          </div>
          <button
            onClick={handleDismiss}
            className="flex-shrink-0 p-1 rounded-lg hover:bg-gray-100 transition-colors text-gray-400 hover:text-gray-600"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification;
